<template>
  <div class="ws-modal">
    <form class="ws-modal__form" @submit.prevent="submit">
      <header class="ws-modal__header">
        <div class="columns">
          <div class="column is-10">
            <h2 class="has-text-weight-bold is-size-1">
              <span v-text="$t('Управление главным экспертом')"></span>
            </h2>
          </div>
        </div>
      </header>
      <div class="ws-modal__content" :class="{'is-loading': isSaving}">
        <ws-experts-types-buttons :isDisableCheckDocs="isDisableCheckDocs" :expert-type="userType" :change-type="onChangeType" />
        <div class="columns">
          <div class="column is-12" :data-competency-guid="exam.accred_comps.competency.guid">
            <ws-experts-search
              v-if="userType === expertTypes.expert"
              :change="updateUsersList"
              :disabled="!isMyDeCenter"
              :expert-search="expertSearch"
              :selected="getSelected(expertTypes.expert)"
              :exam="exam"
              :roles="'main'"
            />

            <ws-users-search
              v-else
              :expert-search="expertSearch"
              :disabled="!isMyDeCenter"
              :change="updateUsersList"
              :selected="getSelected(expertTypes.user)"
            />

            <ws-main-expert-card :isMyDeCenter="isMyDeCenter" v-if="!isSaving" :exam="exam" :expert="expertInfo" @update='onUpdateExpert' />
          </div>
        </div>
      </div>
      <footer class="ws-modal__footer">
        <div class="columns">
          <div class="column is-4"></div>
          <ws-permission-node :resources="['services/de/mainexpert']" :actions="['create']" effect="display">
            <div class="column is-4 is-vcentered">
              <div class="has-text-right-desktop">
                <ws-role-node :except="['front_university', 'front_curator', 'front_rcc']">
                <button
                  class="ws-button button is-large is-primary is-fullwidth"
                  :disabled="isSaving || isMyDeCenter"
                  @click="requestWithoutUser()"
                  type="button"
                >
                  <span class="is-size-4 has-text-weight-bold">{{$t('Заявка без кандидата')}}</span>
                </button>
                </ws-role-node>
              </div>
            </div>
            <div class="column is-4 is-vcentered">
              <div class="has-text-right-desktop">
                <button
                  class="ws-button button is-large is-fullwidth"
                  :class="isExpertDeniedAndNotRequested && !isHasMainExpert ? 'is-danger' : 'is-primary'"
                  type="submit"
                  :disabled="!isHasMainExpert || isSaving || isExpertDeniedAndNotRequested || !isMyDeCenter"
                >
                  <span class="is-size-4 has-text-weight-bold">
                    <ws-role-node :except="['front_mc']">
                      <span v-if="isExpertDeniedAndNotRequested && !isHasMainExpert">{{$t('Выбор недоступен')}}</span>
                      <span v-else>{{$t('Отправить заявку')}}</span>
                    </ws-role-node>
                    <ws-role-node :only="['front_mc']">{{$t('Назначить')}}</ws-role-node>
                  </span>
                </button>
              </div>
            </div>
          </ws-permission-node>
        </div>
      </footer>
    </form>
    <aside class="ws-modal__sidebar">
      <button
        class="ws-button button is-text"
        type="button"
        @click="close"
      >
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'

import WsExpertsTypesButtons from './componets/WsExpertsTypesButtons.vue'
import WsExpertsSearch from './componets/WsExpertsSearch.vue'
import WsMainExpertCard from '../demo-exams/WsMainExpertCard.vue'
import WsUsersSearch from './componets/WsUsersSearch.vue'
import expertStatus from '../demo-exams/data/expertStatusEnum'
import expertTypes from '../demo-exams/data/expertTypesEnum'
import { getPhoneNumbers } from '@/utils/getPhoneNumber'
import validateExpertCertificates from '@/utils/validate-expert-certificates'

const nullGuid = '00000000-0000-0000-0000-000000000000'

export default {
  components: { WsMainExpertCard, WsExpertsTypesButtons, WsExpertsSearch, WsUsersSearch },
  name: 'WsMainExpertManagement',
  props: {
    exam: {
      type: Object
    },
    isMyDeCenter: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      newExam: {},
      experts: [],
      expert: {},
      selectedExpert: {},
      expertSearch: {
        guid: null,
        value: null,
        item: null
      },
      isSaving: false,
      isRejecting: false,
      expertStatus,
      nullGuid,
      isRemote: null,
      isRemotePending: false,
      userType: expertTypes.expert,
      expertTypes
    }
  },
  watch: {
    exam: {
      immediate: true,
      async handler (exam) {
        this.newExam = exam || {}

        if (exam && exam.main_expert) {
          exam.main_expert = { ...exam.main_expert, isNotLocal: true }
        }

        this.expert = exam && exam.main_expert
        this.selectedExpert = exam && exam.main_expert

        let expert
        if (exam.main_expert.guid !== nullGuid) {
          expert = await this.findExperts({
            query: {
              guids: [exam.main_expert.guid],
              competency_guid: exam.accred_comps.competency.guid,
              with_light_certificates: true
            }
          })
        }

        if (expert && expert.length) {
          this.expert = Object.assign(exam.main_expert, {
            user_info: expert[0].user_info,
            attestations: expert[0].attestations,
            certificates: expert[0].certificates
          })
        }

        this.isRemote = exam.flags.indexOf('main_expert_is_remote') > -1
      }
    }
  },
  computed: {
    ...mapState('authentication', ['currentRole']),
    ...mapState('examExtraRules', ['examRules']),
    examExperts () {
      return this.exam.experts ? this.exam.experts : []
    },
    isHasMainExpert () {
      return this.expertInfo.guid !== nullGuid && this.expertInfo.main_expert_role_status === 1
    },
    isDisableCheckDocs () {
      const examFlags = this.exam.flags || []
      const rulesFlags = [
        ...this.examRules.attestation_type,
        ...this.examRules.level_de
      ]
      const isDisableCheck = examFlags.some(flag => rulesFlags.includes(flag))

      return isDisableCheck
    },
    isSubmitDenied () {
      const isValidRole = ['front_curator', 'front_rcc', 'front_admin', 'front_dep'].includes(this.currentRole)

      if ((this.isDisableCheckDocs && isValidRole) ||
      (this.userType === expertTypes.user && ['front_admin', 'front_dep'].includes(this.currentRole))) {
        return false
      }
      const isValidAttestation = validateExpertCertificates(this.expert.attestations, this.exam.ended_at)
      const isValidCertificate = validateExpertCertificates(this.expert.certificates, this.exam.ended_at)
      return !isValidCertificate && !isValidAttestation && !['front_admin', 'front_dep'].includes(this.currentRole)
    },
    isExpertDeniedAndNotRequested () {
      return this.isSubmitDenied && this.expert.expert_exam_status !== this.expertStatus.requested
    },
    expertInfo () {
      const expert = this.expert.user_info || this.expert

      let status = expertStatus.none
      const roleStatus = this.expert.expertType === expertTypes.expert ? this.expert.main_expert_role_status : 1
      if (this.expert.expert_exam_status) {
        status = this.expert.expert_exam_status
      }

      const info = {
        guid: this.expert.guid || null,
        first: get(expert, 'first', { display: '' }),
        last: get(expert, 'last', { display: '' }),
        middle: get(expert, 'middle', { display: '' }),
        region: get(expert, 'region', { title: { display: '' } }),
        phoneNumbers: getPhoneNumbers(expert) || '',
        email: get(expert, 'email', ''),
        isNotLocal: this.expert.isNotLocal || false,
        expert_exam_status: status,
        main_expert_role_status: roleStatus,
        expertType: this.expert.expertType,
        certificates: this.expert.certificates || [],
        attestations: this.expert.attestations || []
      }

      return info
    }
  },
  async created () {
    this.isSaving = true
    try {
      await this.getExamRules()
    } finally {
      this.isSaving = false
    }
  },
  methods: {
    ...mapActions('exams', ['update', 'updateMainExpert', 'deleteMainExpert', 'updateMainExpertStatus']),
    ...mapActions('refbook/experts', {
      findExperts: 'find',
      addUserToExpert: 'addUserToExpert'
    }),
    ...mapActions('examExtraRules', ['getExamRules']),
    getSelected (type) {
      if (this.expert) {
        return [{ ...this.expert, expertType: type }, ...this.examExperts]
      }
      return this.examExperts
    },
    onChangeType (type) {
      this.userType = type
      this.expertSearch = {
        guid: null,
        value: null,
        item: null
      }
    },
    formatUserFullName (user) {
      let fullName = null
      if (user) {
        fullName = `${user.last.display} ${user.first.display} ${user.middle.display}`
      }
      user.fullName = fullName
      return fullName
    },
    updateUsersList (expert, type) {
      if (expert && expert.guid) {
        this.expert = Object.assign({}, { ...expert, expertType: type })
      }
    },
    onUpdateExpert (data) {
      this.expert.expert_exam_status = data.main_expert && data.main_expert.expert_exam_status
      this.expert.changed_at = data.main_expert && data.main_expert.changed_at
      this.$emit('update', data)
    },
    async mainExpertReject (body = '') {
      this.isRejecting = true
      await this.deleteMainExpert([this.exam.guid])
      const updatedExam = await this.updateMainExpertStatus([this.exam.guid, expertStatus.rejected, body])
      this.expert.expert_exam_status = updatedExam.main_expert && updatedExam.main_expert.expert_exam_status
      this.$emit('update', updatedExam)
      this.isRejecting = false
    },
    onMainExpertRejectionWithReason () {
      this.$buefy.dialog.prompt({
        title: this.$t('Причина отклонения'),
        message: this.$t(`Будет создано обращение в тикет системе от имени автора создания заявки. Автору заявки придёт уведомление с указанием причины отклонения`),
        confirmText: this.$t('Отправить'),
        cancelText: this.$t('Отмена'),
        inputAttrs: {
        },
        trapFocus: true,
        onConfirm: async (value) => {
          this.mainExpertReject({ reason: value })
        }
      })
    },
    async requestWithoutUser () {
      this.isSaving = true
      if (this.exam.main_expert.guid !== nullGuid) {
        await this.deleteMainExpert([this.exam.guid])
      }
      let updatedExam
      try {
        updatedExam = await this.updateMainExpertStatus([this.exam.guid, expertStatus.requested])
        this.$emit('close', updatedExam)
        this.close()
      } catch (e) {
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так. Попробуйте еще раз`),
          type: 'is-danger'
        })
      }
    },
    async createExpertFromUser () {
      return this.addUserToExpert({
        guid: this.expert.guid,
        competency: { 'guid': get(this.exam, 'accred_comps.competency.guid') },
        region: { 'guid': get(this.exam, 'de_center.address.region.guid') }
      })
    },
    async saveMainExpert () {
      let updatedExam
      updatedExam = await this.updateMainExpert([this.exam.guid, {
        guid: this.expert.guid,
        competency: {
          guid: this.expert.competency.guid
        },
        region: {
          guid: this.expert.region.guid
        },
        is_remote: this.isRemote,
        expert_exam_status: this.expert.expert_exam_status
      }])
      this.expert.changed_at = updatedExam.main_expert && updatedExam.main_expert.changed_at
      this.newExam.main_expert = this.expert
      if (this.currentRole === 'front_mio' || this.currentRole === 'front_50plus' || this.currentRole === 'front_mc') {
        updatedExam = await this.updateMainExpertStatus([this.exam.guid, status])
      }
      this.$emit('close', updatedExam)
      this.close()
    },
    async submit () {
      this.isSaving = true

      if (this.expert.expertType === expertTypes.user) {
        try {
          const result = await this.createExpertFromUser()
          this.updateUsersList(result[0])

          await this.saveMainExpert()
        } catch (e) {
          this.$buefy.toast.open({
            message: this.$t(`Что-то пошло не так. Попробуйте еще раз`),
            type: 'is-danger'
          })
        } finally {
          this.isSaving = false
        }
      }

      if ((this.expert && this.expert.user_info.guid) === (this.exam.main_expert && this.exam.main_expert.user_info && this.exam.main_expert.user_info.guid)) {
        return this.close()
      }
      if (this.exam.main_expert.guid === nullGuid) {
        await this.saveMainExpert()
        return
      }

      this.$buefy.dialog.confirm({
        title: 'Вы действительно хотите назначить другого эксперта?',
        message: `${this.currentRole === 'front_mio' || this.currentRole === 'front_50plus' ? '' : 'При подтверждении назначение предыдущего эксперта будет сброшено и заявка аннулирована'}`,
        cancelText: 'Отмена',
        confirmText: 'Назначить',
        type: 'is-danger',
        onCancel: () => {
          this.isSaving = false
        },
        onConfirm: async () => {
          await this.saveMainExpert()
        }
      })
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.attention {
  color:#e7a035;
  font-weight: bold;
}

/deep/
.ws-button.is-info.is-outlined:focus,
.ws-button.is-info.is-outlined.is-focused {
  background-color: transparent;
  color: #209cee;
}

@media screen and (min-width: 769px) {
  .ws-members__item.ws-members__item--upt {
    grid-template-columns: 128px minmax(100px, 1fr) 100px 175px;
  }
}
</style>
